import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Svg from "../components/figs/Svg";
import PageName from "../components/PageName";
import HeaderLogo from "../components/HeaderLogo";
import {
  calculateAge,
  fetchAuthPost,
  formatPatternPassengerExcelObjectToFlatPassengerData,
  generatePassengers,
  generatePassengersAndPassengerList,
  generatePassengersAndPassengerListByPassengerList,
  importPassengerExcelToObject,
  joinPassengerListToPassengersAndPassengerList,
  timeToYYYYMMDD,
  validatePassengerObject,
  yyyymmddd_ddmmyyyy_v1,
} from "../functions/functions";
import api from "../routes/api";
import Loading from "../components/Loading";
import { useForm } from "react-hook-form";
import useStaticData from "../hooks/useStaticData";
import { useAlertModal } from "../hooks/useAlertModal";
import { useToast } from "../hooks/useToast";
import ButtonBack from "../components/ButtonBack";
import useSelect from "../hooks/useSelect";
import {
  fetchAgeGroup,
  fetchAgentOption,
  fetchBoatCapacity,
  fetchBoatOption,
  fetchDataList,
  fetchDateOption,
  fetchSeat,
  fetchTourDetail,
  fetchTourOption,
} from "../functions/fetchers";
import PassengerForm from "../components/PassengerForm";
import Step1 from "../components/Step1";
import CardManagePassenger from "../components/CardManagePassenger";
import CardTourDetail from "../components/CardTourDetail";
import CardBoatDetail from "../components/CardBoatDetail";
import Step2DataEdit from "../components/Step2DataEdit";
import GroupCard from "../components/GroupCard";
import { useConfirmModal } from "../hooks/useConfirmModal";
import { useChooseModal } from "../hooks/useChooseModal";
import LoadingOnTop from "../components/LoadingOnTop";

export default function DataEdit() {
  const { msg } = useSelector((state) => state.language);

  const { staticData } = useStaticData();

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingOnTop, setIsLoadingOnTop] = useState(false);

  const importRef = useRef();

  const searchRef = useRef(null);

  const { alert, AlertModal } = useAlertModal();
  const { confirm, ConfirmModal } = useConfirmModal();
  const { showToast, Toasts } = useToast();
  const { choose, ChooseModal } = useChooseModal();

  const formHook = useForm();
  const {
    register,
    setValue,
    trigger,
    handleSubmit,
    watch,
    getValues,
    reset,
    formState: { errors },
  } = formHook;

  const section = watch("_section");
  const subsection = watch("_subsection");
  const id_tour_type = watch("_id_tour_type");
  const tourType = watch("_tourType");
  const tourTypeName = watch("_tourTypeName");
  const showButtonBack = watch("_showButtonBack");
  const id_tour = watch("_id_tour");
  const tourOption = watch("_tourOption") || [];
  const dateOption = watch("_dateOption") || [];
  const date = watch("_date");
  const tourName = watch("_tourName");
  const boatCapacity = watch("_boatCapacity");
  const numOfAdult = watch("_numOfAdult");
  const numOfChild = watch("_numOfChild");
  const numOfInfant = watch("_numOfInfant");
  const seatAvailable = watch("_seatAvailable") || 0;
  const id_boat = watch("_id_boat");
  const boatOption = watch("_boatOption") || [];
  const adultAge = watch("_adultAge");
  const childAge = watch("_childAge");
  const infantAge = watch("_infantAge");
  const isShowButtonDeletePassenger = watch("_isShowButtonDeletePassenger");
  const tourImage = watch("_tourImage");
  const tourDateTime = watch("_tourDateTime");
  const tourTripDuration = watch("_tourTripDuration");
  const tourDestinationList = watch("_tourDestinationList") || [];
  const boatImage = watch("_boatImage");
  const boatName = watch("_boatName");
  const boatType = watch("_boatType");
  const port = watch("_port");
  const registrationNumber = watch("_registrationNumber");
  const passengers = watch("_passengers") || [];
  const genderOption = watch("_genderOption") || [];
  const countryOption = watch("_countryOption") || [];
  const nationalityOption = watch("_nationalityOption") || [];
  const groupId = watch("_groupId");
  const id_agent = watch("id_agent");
  const passenger_list = watch("passenger_list");
  const _bridge_passenger_list = watch("_bridge_passenger_list");
  const isShowFormAddCustomer = watch("_isShowFormAddCustomer");
  const numOfAddAdult = watch("_numOfAddAdult") || 0;
  const numOfAddChild = watch("_numOfAddChild") || 0;
  const numOfAddInfant = watch("_numOfAddInfant") || 0;
  const maxNumOfAddAdult = +seatAvailable - +numOfAddChild - +numOfAddInfant;
  const maxNumOfAddChild = +seatAvailable - +numOfAddAdult - +numOfAddInfant;
  const maxNumOfAddInfant = +seatAvailable - +numOfAddAdult - +numOfAddChild;
  const data_list = watch("_data_list") || [];
  const numOfTotalAdult = watch("_numOfTotalAdult");
  const numOfTotalChild = watch("_numOfTotalChild");
  const numOfTotalInfant = watch("_numOfTotalInfant");
  const filtered_data_list = watch("_filtered_data_list");
  const checkedTourGroupIdList = watch("_checkedTourGroupIdList") || [];
  const isViewForm = watch("_isViewForm");
  const direct_agent_value = watch("_direct_agent_value") || "all";
  const direct_agent_title = watch("_direct_agent_title") || msg.fit_tour;
  const agentOption = watch("_agentOption") || [];

  // const onClickSelectFit = () => {
  //   onSelectTourType("join");
  //   setValue("_direct_agent_value", "direct");
  //   setValue("_direct_agent_title", msg.fit_tour);
  // };

  // const onClickSelectGroup = () => {
  //   onSelectTourType("join");
  //   setValue("_direct_agent_value", "agent");
  //   setValue("_direct_agent_title", msg.group_tour);
  // };

  const onSelectTourType = async (value) => {
    setIsLoadingOnTop(true);
    const temp = staticData.tourTypeList.find((el) => el.tour_type === value);
    const id_tour_type = temp.id_tour_type;
    setValue("_id_tour_type", id_tour_type);
    const tourOption = await fetchTourOption(id_tour_type);
    setValue("_tourOption", tourOption);
    setValue("_tourType", temp.tour_type);
    setValue("_section", "select_tour_date_boat");
    setValue("_id_tour", null);
    setValue("_dateOption", []);
    if (value === "join") {
      setValue("_tourTypeName", msg.join_tour);
    }
    if (value === "private") {
      setValue("_tourTypeName", msg.private_tour);
    }
    setIsLoadingOnTop(false);
  };

  const onSelectTour = async (event) => {
    setIsLoadingOnTop(true);
    const id_tour = +event.target.value;
    setValue("_id_tour", id_tour);
    let dateOption = await fetchDateOption(id_tour_type, id_tour);
    dateOption = dateOption
      .map((el) => ({
        ...el,
        time: new Date(el.value),
      }))
      .sort((a, b) => b.time - a.time)
      .map((el) => ({ label: el.label, value: el.value }));
    setValue("_dateOption", dateOption);
    setIsLoadingOnTop(false);
  };

  const onSelectDate = async (event) => {
    setIsLoading(true);
    const date = event.target.value;
    setValue("_date", date);

    // ดึงข้อมูลพร้อมกัน
    const [boat_option, ageGroup] = await Promise.all([
      fetchBoatOption(id_tour_type, id_tour, date),
      fetchAgeGroup(),
    ]);

    setValue("_boatOption", boat_option);
    const id_boat = boat_option[0]?.value;
    setValue("_id_boat", id_boat);

    const { adult_age, child_age, infant_age } = ageGroup;
    setValue("_adultAge", adult_age);
    setValue("_childAge", child_age);
    setValue("_infantAge", infant_age);

    // ดึงข้อมูลอีกชุดที่ต้องใช้ id_boat
    const [passenger_capacity_company_policy, seat] = await Promise.all([
      fetchBoatCapacity(id_boat),
      fetchSeat(id_tour_type, id_tour, date, id_boat),
    ]);
    setValue("_boatCapacity", passenger_capacity_company_policy);
    setValue("_seat", seat);

    setValue("_numOfAdult", 0);
    setValue("_numOfChild", 0);
    setValue("_numOfInfant", 0);
    setValue("_isShowButtonSubmit", false);

    const tourName = tourOption.find((el) => +el.value === +id_tour)?.label;
    setValue("_tourName", tourName);
    setIsLoading(false);
  };

  const onSelectBoat = async (event) => {
    setIsLoading(true);
    const id_boat = +event.target.value;
    setValue("_id_boat", id_boat);
    setIsLoading(false);
  };

  const onClickBackToStep1 = () => {
    setValue("_id_boat", null);
    setValue("_boatOption", []);
    setValue("_date", null);
  };

  const onClickSubmitStep2 = async () => {
    setIsLoading(true);

    const [data_list, data, agentOption] = await Promise.all([
      fetchDataList(id_tour_type, id_tour, date, id_boat),
      fetchTourDetail(id_tour_type, id_tour, date, id_boat),
      fetchAgentOption(),
    ]);

    setValue("_data_list", data_list);
    setValue("_agentOption", agentOption);

    const tour = data.tour;
    setValue("_tourImage", tour.image);

    const tempTourDateTime = `${yyyymmddd_ddmmyyyy_v1(
      tour?.date || tour?.departure_date
    )}, ${tour?.departure_time} ${msg.to} ${yyyymmddd_ddmmyyyy_v1(
      tour?.date ||
        timeToYYYYMMDD(
          new Date(tour?.departure_date).getTime() +
            +(tour?.night || 0) * 24 * 60 * 60 * 1000
        )
    )}, ${tour?.arrival_time}`;

    setValue("_tourDateTime", tempTourDateTime);

    setValue("_tourTripDuration", tour.trip_duration);

    setValue("_tourDestinationList", tour.destination_list);

    const boat = data.boat;
    setValue("_boatImage", boat.image);
    setValue("_boatName", boat.boat_name);
    setValue("_boatType", boat.boat_type);
    setValue("_port", boat.port);
    setValue("_registrationNumber", boat.registration_no);

    stateSelectAgent.placeholder(msg.agent);
    stateSelectAgent.multiple(false);
    stateSelectAgent.setOption(agentOption);
    stateSelectAgent.setOnSaveAddNewOption(onAddNewAgentOption);

    setValue(
      "_genderOption",
      staticData.genderList.map((el) => ({
        value: el.id_gender,
        label: el.gender,
      }))
    );

    setValue(
      "_countryOption",
      staticData.countryList.map((el) => ({
        value: el.id_country,
        label: el.label_en,
      }))
    );

    setValue(
      "_nationalityOption",
      staticData.nationalityList.map((el) => ({
        value: el.id_nationality,
        label: el.label_en,
      }))
    );

    const numOfTotalAdult = data_list.reduce(
      (acc, el) => acc + el.num_of_adult,
      0
    );
    const numOfTotalChild = data_list.reduce(
      (acc, el) => acc + el.num_of_child,
      0
    );
    const numOfTotalInfant = data_list.reduce(
      (acc, el) => acc + el.num_of_infant,
      0
    );
    setValue("_numOfTotalAdult", numOfTotalAdult);
    setValue("_numOfTotalChild", numOfTotalChild);
    setValue("_numOfTotalInfant", numOfTotalInfant);

    setValue("_numOfAdult", 0);
    setValue("_numOfChild", 0);
    setValue("_numOfInfant", 0);

    const numOfTotalPassenger =
      numOfTotalAdult + numOfTotalChild + numOfTotalInfant;
    const seatAvailable = boatCapacity - numOfTotalPassenger;
    setValue("_seatAvailable", seatAvailable);

    setValue("_subsection", "datalist");
    setValue("_section", "form");

    setIsLoading(false);
  };

  const onCheckedGroup = (event, data) => {
    if (event.target.checked) {
      setValue("_checkedTourGroupIdList", [
        ...checkedTourGroupIdList,
        data.id_tour_group,
      ]);
    } else {
      setValue(
        "_checkedTourGroupIdList",
        checkedTourGroupIdList.filter((el) => el !== data.id_tour_group)
      );
    }
  };

  const onDeleteGroup = async () => {
    try {
      const isConfirmDelete = await confirm(
        msg.delete_data,
        msg.are_you_sure_want_to_delete_this_data
      );
      if (!isConfirmDelete) return;
      setIsLoading(true);
      const response = await fetchAuthPost(api.entry.deleteEntry, {
        data: { id_tour_group_list: checkedTourGroupIdList },
      });
      if (response.status === "error") throw response;

      const data_list = await fetchDataList(
        id_tour_type,
        id_tour,
        date,
        id_boat
      );

      const numOfTotalAdult = data_list.reduce(
        (acc, el) => acc + el.num_of_adult,
        0
      );
      const numOfTotalChild = data_list.reduce(
        (acc, el) => acc + el.num_of_child,
        0
      );
      const numOfTotalInfant = data_list.reduce(
        (acc, el) => acc + el.num_of_infant,
        0
      );
      setValue("_numOfTotalAdult", numOfTotalAdult);
      setValue("_numOfTotalChild", numOfTotalChild);
      setValue("_numOfTotalInfant", numOfTotalInfant);
      setValue(
        "_seatAvailable",
        +boatCapacity -
          +data_list.reduce((acc, el) => acc + +el.num_of_total_passenger, 0)
      );

      setValue("_data_list", data_list);
      setValue("_filtered_data_list", null);
      setValue("_checkedTourGroupIdList", []);
      showToast(response.msg, 3000);
    } catch (error) {
      console.error(error);
      alert(msg.alert, error.msg);
    } finally {
      setIsLoading(false);
    }
  };

  const onFilterGroup = (e) => {
    const value = e.target.value;
    let temp = data_list
      .map((el) => ({
        ...el,
        agent: agentOption.find((a) => +a.value === +el.id_agent)?.label,
      }))
      .filter((el) => {
        if (direct_agent_value === "all") {
          return true;
        } else if (direct_agent_value === "direct") {
          return Boolean(el.id_agent) === false;
        } else if (direct_agent_value === "agent") {
          return Boolean(el.id_agent) === true;
        }
      });

    if (value) {
      temp = temp.filter(
        (el) =>
          `${el.group_id}`.toLowerCase().includes(value.toLowerCase()) ||
          `${el.agent}`.toLowerCase().includes(value.toLowerCase())
      );
      setValue("_filtered_data_list", temp);
    } else {
      if (temp.length === 0 && direct_agent_value === "all") {
        setValue("_filtered_data_list", null);
      } else {
        setValue("_filtered_data_list", temp);
      }
    }
  };

  const onViewGroup = async (data) => {
    setIsLoading(true);
    setValue("_filtered_data_list", null);

    const { id_tour_group } = data;
    setValue("id_tour_group", id_tour_group);

    const [passengerData, responseAgentList] = await Promise.all([
      fetchAuthPost(api.entry.readEntry, {
        data: { id_tour_group },
      }).then((r) => r.data),
      fetchAuthPost(api.setting.readAgentList),
    ]);

    const tempOption = responseAgentList.data.map((el) => ({
      value: el.id_agent,
      label: el.agent,
    }));

    if (passengerData?.id_agent) {
      stateSelectAgent.setSelectedOption([
        {
          value: passengerData.id_agent,
          label: tempOption.find((el) => +el.value === +passengerData.id_agent)
            .label,
        },
      ]);
      setValue("id_agent", passengerData.id_agent);
    } else {
      stateSelectAgent.setSelectedOption([]);
      setValue("id_agent", null);
    }

    const { group_id: groupId } = passengerData;
    setValue("_groupId", groupId);

    const { adult, child, infant } = passengerData;
    const tempPassengerList = {
      adult,
      child,
      infant,
    };
    const tempNumOfAdult = (adult || []).length;
    const tempNumOfChild = (child || []).length;
    const tempNumOfInfant = (infant || []).length;
    let tempPassengers = generatePassengers(
      msg["adult(s)"],
      msg["child(s)"],
      msg["infant(s)"],
      tempNumOfAdult,
      tempNumOfChild,
      tempNumOfInfant
    );

    const isViewForm = true;
    stateSelectAgent.disabled(isViewForm);
    setValue("_isViewForm", isViewForm);

    tempPassengers = tempPassengers.map((el) => {
      const na = tempPassengerList[el.ageGroup][el.index].na;
      const fill_later = tempPassengerList[el.ageGroup][el.index].fill_later;
      return {
        ...el,
        isView: isViewForm,
        isDisabledDateOfBirth: na,
        isDisabledFirstName: fill_later,
        isDisabledLastName: fill_later,
        isCheckedFillLater: fill_later,
      };
    });
    setValue("_passengers", tempPassengers);
    setValue("_bridge_passenger_list", tempPassengerList);

    setValue("_numOfAdult", tempNumOfAdult);
    setValue("_numOfChild", tempNumOfChild);
    setValue("_numOfInfant", tempNumOfInfant);

    setValue("_subsection", "form");
    setIsLoading(false);
  };

  const onEdit = () => {
    setValue("_isViewForm", false);
    stateSelectAgent.disabled(false);
  };

  const onCancel = () => {
    const oldState = getValues();
    const newState = {
      ...oldState,
      _bridge_passenger_list: [],
      _seatAvailable:
        +boatCapacity -
        +data_list.reduce((acc, el) => acc + +el.num_of_total_passenger, 0),
      _subsection: "datalist",
    };
    reset(newState);
  };

  const onUpdate = async (data) => {
    try {
      setIsLoading(true);

      let { adult, child, infant } = data.passenger_list;
      adult = (adult || []).map((el) => ({
        ...el,
        age_group: "adult",
      }));
      child = (child || []).map((el) => ({
        ...el,
        age_group: "child",
      }));
      infant = (infant || []).map((el) => ({
        ...el,
        age_group: "infant",
      }));

      const flatPassengerList = [...adult, ...child, ...infant].map((el) => ({
        id_passenger: el.id_passenger,
        checkin_no: el.checkin_no,
        fill_later: el.fill_later,
        firstname: el.firstname,
        lastname: el.lastname,
        id_gender: el.id_gender || null,
        date_of_birth: el.date_of_birth,
        na: el.na,
        age: el.age || null,
        id_country: el.id_country || null,
        id_nationality: el.id_nationality || null,
        id_passport_no: el.id_passport_no,
        hotel_address: el.hotel_address,
        voucher_no: el.voucher_no,
        age_group: el.age_group,
      }));

      const payload = {
        data: {
          flat_passenger_list: flatPassengerList,
          id_agent: data?.id_agent || null,
          id_tour_group: data.id_tour_group,
        },
      };

      const response = await fetchAuthPost(api.entry.updateEntry, payload);
      if (response.status === "error") throw response;
      showToast(response.msg, 3000);
      setValue("_bridge_passenger_list", []);
      const data_list = await fetchDataList(
        id_tour_type,
        id_tour,
        date,
        id_boat
      );

      const numOfTotalAdult = data_list.reduce(
        (acc, el) => acc + el.num_of_adult,
        0
      );
      const numOfTotalChild = data_list.reduce(
        (acc, el) => acc + el.num_of_child,
        0
      );
      const numOfTotalInfant = data_list.reduce(
        (acc, el) => acc + el.num_of_infant,
        0
      );
      setValue("_numOfTotalAdult", numOfTotalAdult);
      setValue("_numOfTotalChild", numOfTotalChild);
      setValue("_numOfTotalInfant", numOfTotalInfant);
      setValue(
        "_seatAvailable",
        +boatCapacity -
          +data_list.reduce((acc, el) => acc + +el.num_of_total_passenger, 0)
      );
      setValue("_data_list", data_list);
      setValue("_subsection", "datalist");
    } catch (error) {
      console.error(error);
      alert(msg.alert, error.msg || msg.try_again);
    } finally {
      setIsLoading(false);
    }
  };

  const init = async () => {
    await onSelectTourType("join");
    setValue("_section", "select_tour_date_boat");
    setValue("_showButtonBack", false);
    setIsLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  const onClickButtonBack = () => {
    if (subsection === "form") {
      setValue("_subsection", "datalist");
      return;
    }
    reset({
      _section: "select_tour_date_boat",
      _showButtonBack: false,
    });
    onSelectTourType("join");
  };

  const onChangeGender = (event, data) => {
    const { prefix, ageGroup, index } = data;
    const id_gender = +event.target.value;
    setValue(`${prefix}.${ageGroup}.${index}.id_gender`, id_gender);
  };

  const onChangeDateOfBirth = (event, data) => {
    const { prefix, ageGroup, index } = data;
    const age = +calculateAge(event.target.value);
    setValue(`${prefix}.${ageGroup}.${index}.age`, age);
  };

  const onChangeNA = (event, data) => {
    const { prefix, ageGroup, index } = data;
    const isChecked = event.target.checked;
    const temp = passengers.map((el) => {
      if (
        el.prefix === prefix &&
        el.ageGroup === ageGroup &&
        el.index === index
      ) {
        if (isChecked) {
          setValue(`${prefix}.${ageGroup}.${index}.date_of_birth`, null);
        } else {
          setValue(`${prefix}.${ageGroup}.${index}.age`, null);
        }
        return {
          ...el,
          isDisabledAge: !isChecked,
          isDisabledDateOfBirth: isChecked,
        };
      } else {
        return el;
      }
    });
    setValue("_passengers", temp);
  };

  const onChangeFillLater = (event, data) => {
    const { prefix, ageGroup, index } = data;
    const isChecked = event.target.checked;
    const temp = passengers.map((el) => {
      if (
        el.prefix === prefix &&
        el.ageGroup === ageGroup &&
        el.index === index
      ) {
        if (isChecked) {
          setValue(`${prefix}.${ageGroup}.${index}.firstname`, null);
          setValue(`${prefix}.${ageGroup}.${index}.lastname`, null);
        }
        return {
          ...el,
          isDisabledFirstName: isChecked,
          isDisabledLastName: isChecked,
          isCheckedFillLater: isChecked,
        };
      } else {
        return el;
      }
    });
    setValue("_passengers", temp);
  };

  const [stateSelectAgent, SelectAgent] = useSelect();

  const onAddNewAgentOption = async () => {
    const data = stateSelectAgent.getTextForSaveAddNewOption();
    await fetchAuthPost(api.setting.createAgent, {
      data: { agent: data },
    });
    const responseAgentList = await fetchAuthPost(api.setting.readAgentList);
    const tempOption = responseAgentList.data.map((el) => ({
      value: el.id_agent,
      label: el.agent,
    }));
    setValue("_agentOption", tempOption);
    stateSelectAgent.setOption(tempOption);
  };

  const onClickAddCustomer = () => {
    setValue("_numOfAddAdult", 0);
    setValue("_numOfAddChild", 0);
    setValue("_numOfAddInfant", 0);
    if (isShowFormAddCustomer) {
      setValue("_isShowFormAddCustomer", false);
    } else {
      setValue("_isShowFormAddCustomer", true);
    }
  };

  const onClickCancelAddCustomer = () => {
    setValue("_isShowFormAddCustomer", false);
  };

  const onClickSubmitAddCustomer = () => {
    const [oldPassengers, oldPassengerList] =
      generatePassengersAndPassengerListByPassengerList(
        msg["adult(s)"],
        msg["child(s)"],
        msg["infant(s)"],
        passenger_list
      );
    const [addPassengers, addPassengerList] =
      generatePassengersAndPassengerList(
        msg["adult(s)"],
        msg["child(s)"],
        msg["infant(s)"],
        +numOfAddAdult,
        +numOfAddChild,
        +numOfAddInfant
      );

    const [newPassengers, newPassengerList] =
      joinPassengerListToPassengersAndPassengerList(
        msg["adult(s)"],
        msg["child(s)"],
        msg["infant(s)"],
        oldPassengerList,
        addPassengerList
      );

    const newNumOfAdult = newPassengerList.adult.length;
    const newNumOfChild = newPassengerList.child.length;
    const newNumOfInfant = newPassengerList.infant.length;

    setValue("_numOfAdult", newNumOfAdult);
    setValue("_numOfChild", newNumOfChild);
    setValue("_numOfInfant", newNumOfInfant);
    const newSeatAvailable =
      +seatAvailable - +numOfAddAdult - +numOfAddChild - +numOfAddInfant;
    setValue("_seatAvailable", newSeatAvailable);

    setValue("_bridge_passenger_list", newPassengerList);
    setValue("_passengers", newPassengers);
    setValue("_isShowFormAddCustomer", false);
  };

  const onClickDeletePassenger = () => {
    const uncheckedAdultIndexList = passengers
      .filter((el) => el.ageGroup === "adult" && el.isChecked === false)
      .map((el) => el.index);
    const uncheckedChildIndexList = passengers
      .filter((el) => el.ageGroup === "child" && el.isChecked === false)
      .map((el) => el.index);
    const uncheckedInfantIndexList = passengers
      .filter((el) => el.ageGroup === "infant" && el.isChecked === false)
      .map((el) => el.index);

    const oldPassengerData = passenger_list;

    const adultPassengerData = oldPassengerData?.adult || [];
    const childPassengerData = oldPassengerData?.child || [];
    const infantPassengerData = oldPassengerData?.infant || [];

    const newAdultData = adultPassengerData.filter((el, index) =>
      uncheckedAdultIndexList.includes(index)
    );
    const newChildData = childPassengerData.filter((el, index) =>
      uncheckedChildIndexList.includes(index)
    );
    const newInfantData = infantPassengerData.filter((el, index) =>
      uncheckedInfantIndexList.includes(index)
    );

    const new_passenger_list = {
      adult: newAdultData || [],
      child: newChildData || [],
      infant: newInfantData || [],
    };

    let uncheckedPassengers = passengers.filter((el) => el.isChecked === false);
    const uncheckedAdult = uncheckedPassengers
      .filter((el) => el.ageGroup === "adult")
      .map((el, index) => ({ ...el, index }));
    const uncheckedChild = uncheckedPassengers
      .filter((el) => el.ageGroup === "child")
      .map((el, index) => ({ ...el, index }));
    const uncheckedInfant = uncheckedPassengers
      .filter((el) => el.ageGroup === "infant")
      .map((el, index) => ({ ...el, index }));
    uncheckedPassengers = [
      ...uncheckedAdult,
      ...uncheckedChild,
      ...uncheckedInfant,
    ];

    const newNumOfAdult = uncheckedAdult.length;
    const newNumOfChild = uncheckedChild.length;
    const newNumOfInfant = uncheckedInfant.length;

    const newPassengers = uncheckedPassengers.map((el, index) => ({
      ...el,
      number: index + 1,
      isChecked: false,
    }));

    const checkedPassengers = passengers.filter((el) => el.isChecked === true);
    const newSeatAvailable = +seatAvailable + checkedPassengers.length;

    const oldState = getValues();
    const newState = {
      ...oldState,
      _bridge_passenger_list: new_passenger_list,
      _numOfAdult: newNumOfAdult,
      _numOfChild: newNumOfChild,
      _numOfInfant: newNumOfInfant,
      _passengers: newPassengers,
      _seatAvailable: newSeatAvailable,
    };
    reset(newState);
  };

  const onClickImportFile = () => {
    importRef.current.value = null;
    importRef.current.click();
  };

  const onChangeImportFile = async () => {
    const file = importRef.current.files;
    if (!file[0]) return;

    const passengerExcelObject = await importPassengerExcelToObject(file[0]);
    const notPassPassengerExcelObject =
      validatePassengerObject(passengerExcelObject);

    if (notPassPassengerExcelObject.length > 0) {
      alert(
        msg.alert,
        `${msg.no}. ${notPassPassengerExcelObject.join(", ")} ${
          msg.not_complete
        }`
      );
      return;
    }

    const importOption = [
      {
        value: "replace",
        label: msg.replace_data,
      },
      {
        value: "insert",
        label: msg.insert_data,
      },
    ];
    const choice = await choose(msg.import, "", importOption);

    if (!choice) return;

    let seatEnough;
    if (choice === "replace") {
      seatEnough =
        passengerExcelObject.length <=
        seatAvailable + numOfTotalAdult + numOfTotalChild + numOfTotalInfant;
    } else if (choice === "insert") {
      seatEnough = passengerExcelObject.length <= seatAvailable;
    }
    if (!seatEnough) {
      alert(msg.alert, msg.not_enough_boat_seats_available);
      return;
    }

    const passengerDataList =
      formatPatternPassengerExcelObjectToFlatPassengerData(
        passengerExcelObject,
        genderOption,
        countryOption,
        nationalityOption,
        adultAge,
        childAge,
        infantAge
      );
    const addAdultData = passengerDataList.filter(
      (el) => el.age_group === "adult"
    );
    const addChildData = passengerDataList.filter(
      (el) => el.age_group === "child"
    );
    const addInfantData = passengerDataList.filter(
      (el) => el.age_group === "infant"
    );

    const tempNewPassengerList = {
      adult: addAdultData,
      child: addChildData,
      infant: addInfantData,
    };

    let newPassengersForm = [];
    let newPassengerList = [];
    // remove all old and paste new
    if (choice === "replace") {
      [newPassengersForm, newPassengerList] =
        generatePassengersAndPassengerListByPassengerList(
          msg["adult(s)"],
          msg["child(s)"],
          msg["infant(s)"],
          tempNewPassengerList
        );
    }
    // paste continue
    if (choice === "insert") {
      const oldPassengerList = passenger_list;
      [newPassengersForm, newPassengerList] =
        joinPassengerListToPassengersAndPassengerList(
          msg["adult(s)"],
          msg["child(s)"],
          msg["infant(s)"],
          oldPassengerList,
          tempNewPassengerList
        );
    }
    setValue("_bridge_passenger_list", newPassengerList);
    setValue("_passengers", newPassengersForm);

    const newNumOfAdult = newPassengerList.adult.length;
    const newNumOfChild = newPassengerList.child.length;
    const newNumOfInfant = newPassengerList.infant.length;

    const newSeatAvailable =
      seatAvailable +
      numOfAdult +
      numOfChild +
      numOfInfant -
      newNumOfAdult -
      newNumOfChild -
      newNumOfInfant;
    setValue("_seatAvailable", newSeatAvailable);

    setValue("_numOfAdult", newNumOfAdult);
    setValue("_numOfChild", newNumOfChild);
    setValue("_numOfInfant", newNumOfInfant);
  };

  const onCheckPassengerForm = (event, passenger) => {
    const indexNumberThatUpdate = passenger.number;
    const updateTo = event.target.checked;
    const temp = passengers.map((el) => {
      if (indexNumberThatUpdate === el.number) {
        return { ...el, isChecked: updateTo };
      } else {
        return el;
      }
    });
    const numOfUncheckedAdult = temp.filter(
      (el) => el.ageGroup === "adult" && el.isChecked === false
    ).length;
    let updated;
    if (numOfUncheckedAdult === 1) {
      updated = temp.map((el) => {
        if (el.ageGroup === "adult" && el.isChecked === false) {
          return { ...el, selectable: false };
        } else {
          return el;
        }
      });
    } else {
      updated = temp.map((el) => ({ ...el, selectable: true }));
    }
    setValue("_passengers", updated);
  };

  useEffect(() => {
    if (section === "select_tour_date_boat") {
      setValue("_showButtonBack", false);
    } else if (section === "form") {
      setValue("_showButtonBack", true);
    } else {
      setValue("_showButtonBack", false);
    }
  }, [section]);

  useEffect(() => {
    if (isViewForm) {
      const temp = passengers.map((el) => ({ ...el, selectable: false }));
      setValue("_passengers", temp);
    } else {
      const isSingleAdult =
        passengers.filter((el) => el.ageGroup === "adult").length === 1;
      let temp;
      if (isSingleAdult) {
        temp = passengers.map((el) => ({
          ...el,
          selectable: el.ageGroup !== "adult",
        }));
      } else {
        temp = passengers.map((el) => ({ ...el, selectable: true }));
      }
      setValue("_passengers", temp);
    }
  }, [isViewForm]);

  useEffect(() => {
    const selected_id_agent_option = stateSelectAgent.getSelectedOption;
    setValue("id_agent", selected_id_agent_option[0]?.value);
  }, [stateSelectAgent.getSelectedOption]);

  useEffect(() => {
    if (numOfAdult > 0) {
      setValue("_isShowButtonSubmit", true);
    } else {
      setValue("_isShowButtonSubmit", false);
    }
  }, [numOfAdult]);

  useEffect(() => {
    if (id_agent) {
      trigger("id_agent");
    }
  }, [id_agent]);

  useEffect(() => {
    if ((passengers || []).length > 0) {
      const isCheckedMoreThanZero =
        passengers.filter((el) => el.isChecked).length > 0;
      setValue("_isShowButtonDeletePassenger", isCheckedMoreThanZero);
    }
  }, [passengers]);

  useEffect(() => {
    if (_bridge_passenger_list) {
      setValue("passenger_list", _bridge_passenger_list);
      setValue("_bridge_passenger_list", null);
    }
  }, [_bridge_passenger_list]);

  useEffect(() => {
    if (+numOfAddAdult > +maxNumOfAddAdult) {
      setValue("_numOfAddAdult", maxNumOfAddAdult);
    }
  }, [numOfAddAdult]);
  useEffect(() => {
    if (+numOfAddChild > +maxNumOfAddChild) {
      setValue("_numOfAddChild", maxNumOfAddChild);
    }
  }, [numOfAddChild]);
  useEffect(() => {
    if (+numOfAddInfant > +maxNumOfAddInfant) {
      setValue("_numOfAddInfant", maxNumOfAddInfant);
    }
  }, [numOfAddInfant]);
  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.value = "";
    }
    onFilterGroup({
      target: { value: "" },
    });
  }, [direct_agent_value]);

  if (isLoading) return <Loading />;
  return (
    <div
      className={`page_data_edit ${
        id_tour_type ? "for_section_2" : "for_section_1"
      }`}
    >
      <ButtonBack hidden={!showButtonBack} onClick={onClickButtonBack} />
      <HeaderLogo />
      <div className="container-section">
        {/* {section === "select_tour_type" && (
          <div className="section_1">
            <PageName titleName={msg.data_edit} />
            <div className="main_button">
              <div onClick={onClickSelectFit} className="blue_button">
                <Svg iconName="blue_button_1" />
                <div className="btn_1">
                  <h2>{msg.fit_tour}</h2>
                  <h3>({msg.direct})</h3>
                </div>
              </div>
              <div onClick={onClickSelectGroup} className="blue_button">
                <Svg iconName="blue_button_2" />
                <div className="btn_2">
                  <h2>{msg.group_tour}</h2>
                  <h3>({msg.travel_agent})</h3>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {section === "select_tour_date_boat" && (
          <div className="section_2">
            <PageName titleName={msg.data_edit} />
            {!(id_tour && date) ? (
              <Step1
                dateOption={dateOption}
                msg={msg}
                nameTour={"_id_tour"}
                nameDate={"_date"}
                register={register}
                tourOption={tourOption}
                onSelectTour={onSelectTour}
                onSelectDate={onSelectDate}
                tourType={tourType}
                onSelectTourTypeJoin={() => onSelectTourType("join")}
                onSelectTourTypePrivate={() => onSelectTourType("private")}
              />
            ) : (
              <Step2DataEdit
                msg={msg}
                register={register}
                nameBoat={"_id_boat"}
                boatOption={boatOption}
                onSelectBoat={onSelectBoat}
                onClickBack={onClickBackToStep1}
                onClickSubmit={onClickSubmitStep2}
              />
            )}
          </div>
        )}

        {section === "form" && (
          <div className="section_3">
            <PageName titleName={msg.data_edit} />
            <div className="passenger_form_layout">
              <div className="card-tour-boat-detail">
                <CardManagePassenger
                  msg={msg}
                  tourTypeName={tourTypeName}
                  onClickDelete={onClickDeletePassenger}
                  isShowButtonDelete={isShowButtonDeletePassenger}
                  isShowButtonAddCustomer={
                    subsection === "form" && isViewForm === false
                  }
                  numOfAdult={
                    subsection === "datalist" ? numOfTotalAdult : numOfAdult
                  }
                  numOfChild={
                    subsection === "datalist" ? numOfTotalChild : numOfChild
                  }
                  numOfInfant={
                    subsection === "datalist" ? numOfTotalInfant : numOfInfant
                  }
                  seatAvailable={seatAvailable}
                  boatCapacity={boatCapacity}
                  onClickAddCustomer={onClickAddCustomer}
                  isShowFormAddCustomer={isShowFormAddCustomer}
                  onClickCancel={onClickCancelAddCustomer}
                  onClickSubmit={onClickSubmitAddCustomer}
                  nameNumOfAddAdult="_numOfAddAdult"
                  nameNumOfAddChild="_numOfAddChild"
                  nameNumOfAddInfant="_numOfAddInfant"
                  register={register}
                  maxNumOfAddAdult={maxNumOfAddAdult}
                  maxNumOfAddChild={maxNumOfAddChild}
                  maxNumOfAddInfant={maxNumOfAddInfant}
                />
                <div className="card_tour_detail">
                  <CardTourDetail
                    srcImage={tourImage}
                    tourName={tourName}
                    tourDateTime={tourDateTime}
                    tourTripDuration={tourTripDuration}
                    tourDestinationList={tourDestinationList}
                  />
                  <CardBoatDetail
                    msg={msg}
                    srcImage={boatImage}
                    boatName={boatName}
                    boatType={boatType}
                    port={port}
                    registrationNumber={registrationNumber}
                    passengerCapacity={boatCapacity}
                  />
                  {subsection === "form" && (
                    <div className="agent_group_id">
                      {id_agent && (
                        <div className="_input_text_select agent">
                          <label>{`${msg.agent} *`}</label>
                          <input
                            type="hidden"
                            {...register("id_agent", { required: true })}
                          />
                          <div
                            className={
                              errors?.id_agent ? "_data_invalid rounded-lg" : ""
                            }
                          >
                            {SelectAgent}
                          </div>
                        </div>
                      )}
                      <div className="group_id_import">
                        <span>{`${msg.group_id} : ${groupId}`}</span>
                        <span>
                          <button>
                            <a
                              href="/static/Agentmarine_importguest.xltx"
                              download
                            >
                              {msg.template}
                            </a>
                          </button>
                          {isViewForm === false && (
                            <>
                              <button onClick={onClickImportFile}>
                                {msg.import}
                              </button>
                              <input
                                hidden
                                type="file"
                                ref={importRef}
                                onChange={onChangeImportFile}
                                accept=".xlsx, .xls"
                              />
                            </>
                          )}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {subsection === "datalist" && (
                <div className="container-data-list">
                  <div className="data_container data_list_container">
                    <div className="data_card_list_header">
                      <span className="left_at_header">
                        <span>{msg.data_list}</span>
                        <span className="button_group">
                          <button
                            onClick={() =>
                              setValue("_direct_agent_value", "all")
                            }
                            className={
                              direct_agent_value === "all"
                                ? "_fill_button"
                                : "_outline_button"
                            }
                          >
                            {msg.all}
                          </button>
                          <button
                            onClick={() =>
                              setValue("_direct_agent_value", "direct")
                            }
                            className={
                              direct_agent_value === "direct"
                                ? "_fill_button"
                                : "_outline_button"
                            }
                          >
                            {msg.fit_tour}
                          </button>
                          <button
                            onClick={() =>
                              setValue("_direct_agent_value", "agent")
                            }
                            className={
                              direct_agent_value === "agent"
                                ? "_fill_button"
                                : "_outline_button"
                            }
                          >
                            {msg.group_tour}
                          </button>
                        </span>
                      </span>
                      <span className="right_at_header">
                        <span
                          className={`search_input ${
                            checkedTourGroupIdList.length > 0
                              ? "has_checked"
                              : ""
                          }`}
                        >
                          <Svg iconName="search" className="size-4" />
                          <input
                            ref={searchRef}
                            onChange={onFilterGroup}
                            placeholder={msg.search}
                          />
                        </span>
                        {checkedTourGroupIdList.length > 0 && (
                          <span onClick={onDeleteGroup} className="delete_icon">
                            <Svg iconName="delete" />
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="data_card_list_body">
                      {(filtered_data_list || data_list).map((el) => (
                        <GroupCard
                          key={el.group_id}
                          msg={msg}
                          numOfAdult={el.num_of_adult}
                          numOfChild={el.num_of_child}
                          numOfInfant={el.num_of_infant}
                          groupId={el.group_id}
                          agent={
                            agentOption.find(
                              (el2) => +el2.value === +el.id_agent
                            )?.label
                          }
                          onCheck={(event) => {
                            onCheckedGroup(event, el);
                          }}
                          onView={() => onViewGroup(el)}
                          disabledCheckbox={
                            new Date(
                              timeToYYYYMMDD(new Date().getTime())
                            ).getTime() > new Date(date).getTime()
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {subsection === "form" && (
                <div className="passenger_form_block">
                  <div className="passenger_form_container">
                    {passengers.map((el, index) => (
                      <PassengerForm
                        key={index}
                        msg={msg}
                        {...el}
                        selectable={
                          el.selectable &&
                          new Date(
                            timeToYYYYMMDD(
                              new Date().getTime() - 24 * 60 * 60 * 1000
                            )
                          ).getTime() < new Date(date).getTime()
                        }
                        register={register}
                        errors={errors}
                        genderOption={genderOption}
                        countryOption={countryOption}
                        nationalityOption={nationalityOption}
                        onCheck={(event) => onCheckPassengerForm(event, el)}
                        isChecked={el.isChecked}
                        onChangeNA={(event) => onChangeNA(event, el)}
                        onChangeFillLater={(event) =>
                          onChangeFillLater(event, el)
                        }
                        onChangeDateOfBirth={(event) =>
                          onChangeDateOfBirth(event, el)
                        }
                        isView={isViewForm}
                        onChangeGender={(event) => onChangeGender(event, el)}
                        defaultGender={watch(
                          `${el.prefix}.${el.ageGroup}.${el.index}.id_gender`
                        )}
                      />
                    ))}
                  </div>
                  <div className="button_container">
                    {isViewForm ? (
                      <>
                        <button
                          className={
                            new Date(
                              timeToYYYYMMDD(new Date().getTime())
                            ).getTime() > new Date(date).getTime()
                              ? "_fill_button disabled"
                              : "_fill_button"
                          }
                          onClick={
                            new Date(
                              timeToYYYYMMDD(new Date().getTime())
                            ).getTime() > new Date(date).getTime()
                              ? () => {}
                              : onEdit
                          }
                          // className="_fill_button"
                          // onClick={onEdit}
                        >
                          {msg.edit}
                        </button>
                      </>
                    ) : (
                      <>
                        <button className="_outline_button" onClick={onCancel}>
                          {msg.cancel}
                        </button>
                        <button
                          className="_fill_button"
                          onClick={handleSubmit(onUpdate)}
                        >
                          {msg.update}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {ChooseModal}
      {AlertModal}
      {ConfirmModal}
      {Toasts}
      {isLoadingOnTop && <LoadingOnTop />}
    </div>
  );
}
